const getPartnerIdKey = (browseCountry, production) => {
  if (!browseCountry) {
    return null;
  }

  if (!production) {
    return `${browseCountry}_TEST`;
  }

  return browseCountry;
};

export default getPartnerIdKey;
